<template>
  <div>
    <table class="table table-bordered table-responsive">
      <thead>
        <tr>
          <th>File Upload</th>
          <th>Nomor</th>
          <th>Tanggal</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Identitas (KTP/NPWP/SIM)</td>
          <td>{{ $store.state.barpin.header.no_identitas }}</td>
          <td></td>
          <td>
            <a target="_blank" v-if="this.$store.state.barpin.files.file_identitas_penerima"
              :href="`${this.$http.options.base}/file/ppftz/${this.$route.params.id}/${this.$store.state.barpin.files.file_identitas_penerima}`">
              <b-button variant="warning">
                <i class="fa fa-download"></i>
              </b-button>
            </a>
          </td>
        </tr>
        <tr v-if="$store.state.barpin.header.fl_kuasa">
          <td>Identitas Kuasa (KTP/NPWP/SIM)</td>
          <td>{{ $store.state.barpin.header.no_identitas_kuasa }}</td>
          <td></td>
          <td>
            <a v-if="this.$store.state.barpin.files.file_identitas_pengirim" target="_blank"
              :href="`${this.$http.options.base}/file/ppftz/${this.$route.params.id}/${this.$store.state.barpin.files.file_identitas_pengirim}`">
              <b-button variant="warning">
                <i class="fa fa-download"></i>
              </b-button>
            </a>
          </td>
        </tr>

        <!-- KHUSUS KENDARAAN BERMOTOR -->
        <tr v-if="$store.state.barpin.header.jns_aju === '2'">
          <td>Nomor STNK</td>
          <td>{{ $store.state.barpin.header.no_stnk }}</td>
          <td>{{ $store.state.barpin.header.tgl_stnk }}</td>
          <td>
            <a v-if="this.$store.state.barpin.files.file_stnk" target="_blank"
              :href="`${this.$http.options.base}/file/ppftz/${this.$route.params.id}/${this.$store.state.barpin.files.file_stnk}`">
              <b-button variant="warning">
                <i class="fa fa-download"></i>
              </b-button>
            </a>
          </td>
        </tr>
        <tr v-if="$store.state.barpin.header.jns_aju === '2'">
          <td>Nomor BPKB</td>
          <td>{{ $store.state.barpin.header.no_bpkb }}</td>
          <td>{{ $store.state.barpin.header.tgl_bpkb }}</td>
          <td>
            <a v-if="this.$store.state.barpin.files.file_bpkb" target="_blank"
              :href="`${this.$http.options.base}/file/ppftz/${this.$route.params.id}/${this.$store.state.barpin.files.file_bpkb}`">
              <b-button variant="warning">
                <i class="fa fa-download"></i>
              </b-button>
            </a>
          </td>
        </tr>
        <!--  -->

        <tr v-if="$store.state.barpin.header.jns_aju === '1'">
          <td>Kartu Keluarga</td>
          <td>{{ $store.state.barpin.header.no_kk }}</td>
          <td></td>
          <td>
            <a v-if="this.$store.state.barpin.files.file_kk" target="_blank"
              :href="`${this.$http.options.base}/file/ppftz/${this.$route.params.id}/${this.$store.state.barpin.files.file_kk}`">
              <b-button variant="warning">
                <i class="fa fa-download"></i>
              </b-button>
            </a>
          </td>
        </tr>
        <tr v-if="$store.state.barpin.header.jns_aju === '1'">
          <td>Surat Pindah Dukcapil</td>
          <td>{{ $store.state.barpin.header.no_dukcapil }}</td>
          <td>{{ $store.state.barpin.header.tgl_dukcapil }}</td>
          <td>
            <a v-if="this.$store.state.barpin.files.file_dukcapil" target="_blank"
              :href="`${this.$http.options.base}/file/ppftz/${this.$route.params.id}/${this.$store.state.barpin.files.file_dukcapil}`">
              <b-button variant="warning">
                <i class="fa fa-download"></i>
              </b-button>
            </a>
          </td>
        </tr>
        <tr v-if="$store.state.barpin.header.jns_aju === '1'">
          <td>Surat Keterangan Mutasi/lainnya</td>
          <td>{{ $store.state.barpin.header.no_surat_pindah }}</td>
          <td>{{ $store.state.barpin.header.tgl_pindah }}</td>
          <td>
            <a v-if="this.$store.state.barpin.files.file_pindah" target="_blank"
              :href="`${this.$http.options.base}/file/ppftz/${this.$route.params.id}/${this.$store.state.barpin.files.file_pindah}`">
              <b-button variant="warning">
                <i class="fa fa-download"></i>
              </b-button>
            </a>
          </td>
        </tr>
        <tr v-if="$store.state.barpin.header.fl_kuasa">
          <td>Surat Kuasa</td>
          <td>{{ $store.state.barpin.header.no_surat_kuasa }}</td>
          <td>{{ $store.state.barpin.header.tgl_surat_kuasa }}</td>
          <td>
            <a v-if="this.$store.state.barpin.files.file_kuasa" target="_blank"
              :href="`${this.$http.options.base}/file/ppftz/${this.$route.params.id}/${this.$store.state.barpin.files.file_kuasa}`">
              <b-button variant="warning">
                <i class="fa fa-download"></i>
              </b-button>
            </a>
          </td>
        </tr>
        <tr>
          <td>Surat Pernyataan</td>
          <td>{{ $store.state.barpin.header.no_surat_pernyataan }}</td>
          <td>{{ $store.state.barpin.header.tgl_surat_pernyataan }}</td>
          <td>
            <a v-if="this.$store.state.barpin.files.file_pernyataan" target="_blank"
              :href="`${this.$http.options.base}/file/ppftz/${this.$route.params.id}/${this.$store.state.barpin.files.file_pernyataan}`">
              <b-button variant="warning">
                <i class="fa fa-download"></i>
              </b-button>
            </a>
          </td>
        </tr>
        <tr v-if="$store.state.barpin.header.jns_aju === '1'">
          <td>Surat Rekomendasi BP</td>
          <td>{{ $store.state.barpin.header.no_surat_rekombp }}</td>
          <td>{{ $store.state.barpin.header.tgl_surat_rekombp }}</td>
          <td>
            <a v-if="this.$store.state.barpin.files.file_rekombp" target="_blank"
              :href="`${this.$http.options.base}/file/ppftz/${this.$route.params.id}/${this.$store.state.barpin.files.file_rekombp}`">
              <b-button variant="warning">
                <i class="fa fa-download"></i>
              </b-button>
            </a>
          </td>
        </tr>
        <tr>
          <td>Packing List</td>
          <td>{{ $store.state.barpin.header.no_pl }}</td>
          <td>{{ $store.state.barpin.header.tgl_pl }}</td>
          <td>
            <a v-if="this.$store.state.barpin.files.file_pl" target="_blank"
              :href="`${this.$http.options.base}/file/ppftz/${this.$route.params.id}/${this.$store.state.barpin.files.file_pl}`">
              <b-button variant="warning">
                <i class="fa fa-download"></i>
              </b-button>
            </a>
          </td>
        </tr>
        <tr v-if="$store.state.barpin.header.jns_aju === '2'">
          <td>Bukti Bayar</td>
          <td>{{ $store.state.barpin.header.no_ntpn }}</td>
          <td>{{ $store.state.barpin.header.tgl_ntpn }}</td>
          <td>
            <a v-if="this.$store.state.barpin.files.file_ntpn" target="_blank"
              :href="`${this.$http.options.base}/file/ppftz/${this.$route.params.id}/${this.$store.state.barpin.files.file_ntpn}`">
              <b-button variant="warning">
                <i class="fa fa-download"></i>
              </b-button>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {

}
</script>


// WEBPACK FOOTER //
// src/views/ppftz/browse/ListFilePpftz.vue?184a236e